import { styled, Card } from '@methanesat/ui-components';

export const DrawerCard = styled(Card)(({ theme }) => ({
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    background: theme.palette.paperOverlay,
    '&[data-active]': {
        borderWidth: '3px',
        borderColor: theme.palette.primary,
        borderStyle: 'solid'
    }
}));
